import { observable } from "mobx";
import { Type } from "class-transformer";
import AccountBalanceCheckRequestStatus from "./accountBalanceCheckRequestStatus";
import AccountBalanceCheckRequestPermittedActionsResponse from "./accountBalanceCheckRequestPermittedActionsResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountBalanceCheckRequestDetailResponse {
  @observable
  id!: string;

  @observable
  accountingPeriodTo!: string;

  @observable
  status!: AccountBalanceCheckRequestStatus;

  @observable
  resultFileName?: string;

  @observable
  createdAt!: string;

  @observable
  createdBy?: string;

  @observable
  @Type(() => AccountBalanceCheckRequestPermittedActionsResponse)
  permittedActions!: AccountBalanceCheckRequestPermittedActionsResponse;
}
